import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { supabase } from './services/api';
import './i18n';

import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import UploadPage from './pages/UploadPage';
import AnalysisPage from './pages/AnalysisPage';
import HistoryPage from './pages/HistoryPage';
import SettingsPage from './pages/SettingsPage';
import Header from './components/Header';

function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-500"></div>
      </div>
    );
  }

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        {session && <Header />}
        <Routes>
          <Route path="/login" element={!session ? <LoginPage /> : <Navigate to="/dashboard" replace />} />
          <Route path="/register" element={!session ? <RegisterPage /> : <Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={session ? <DashboardPage /> : <Navigate to="/login" replace />} />
          <Route path="/upload" element={session ? <UploadPage /> : <Navigate to="/login" replace />} />
          <Route path="/history" element={session ? <HistoryPage /> : <Navigate to="/login" replace />} />
          <Route path="/analysis/:id" element={session ? <AnalysisPage /> : <Navigate to="/login" replace />} />
          <Route path="/settings" element={session ? <SettingsPage /> : <Navigate to="/login" replace />} />
          <Route path="/" element={<Navigate to={session ? "/dashboard" : "/login"} replace />} />
          <Route path="*" element={<NotFound session={session} />} />
        </Routes>
      </div>
    </Router>
  );
}

function NotFound({ session }) {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-8">Page not found</p>
        <a href={session ? "/dashboard" : "/login"} className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg inline-block transition-colors">
          {session ? "Go to Dashboard" : "Go to Login"}
        </a>
      </div>
    </div>
  );
}

export default App;
